const CreditCardFacades = (json) => {
    return {
        data: json.reward.description || null,
        image: json.images["1"].ContentDocument?.LatestPublishedVersion?.ContentUrl || null,
        agreement: json.agreement.ContentDocument?.LatestPublishedVersion?.ContentUrl || null
    };
}

export default CreditCardFacades;